<template>
  <v-container fluid>
    <v-list-item three-line>
      <v-list-item-content>
        <p class="display-1 text--primary">
          {{ $t("menu.survey") }}
        </p>
      </v-list-item-content>
    </v-list-item>
    <v-data-table
      :headers="headers"
      :items="surveyTemplateList"
      class="agTable"
      :loading="loading"
      :search="search"
      sort-by="id"
      :no-results-text="$t('general.ui.not_search_found')"
      :no-data-text="$t('general.ui.not_data_found')"
      :loading-text="$t('general.notification.loadData')"
      :footer-props="{
        itemsPerPageText: $t('general.table.itemsPerPageText'),
        pageText: '{0}-{1} ' + $t('general.table.pageText') + ' {2}',
      }"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-row class="d-flex justify-space-between align-baseline">
            <v-col class="pl-0" lg="4" md="4" sm="6" xl="4" cols="6">
              <v-text-field onkeypress="return (event.charCode != 34)"  v-on:keyup.86="replace" v-on:keyup.ctrl.86="replace"
                dense
                filled
                rounded
                color="secondary"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('general.titles.filter')"
                :clearable="true"
                single-line
                hide-details
              />
            </v-col>
            <v-spacer></v-spacer>
            <v-col lg="4" md="4" sm="4" xl="4" cols="4" class="text-end">
              <v-btn
                small
                tile
                :elevation="0"
                color="#d8d8d896"
                style="border-radius: 1.5em;"
                @click="addItem()"
                v-if="check([{ domain: 'surveyAdm', permisions: ['Write'] }])"
              >
                <v-icon small color="#6D6D6D" left>mdi-plus</v-icon>
                {{ $t("general.buttons.new") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-toolbar>
      </template>
      <template v-slot:item.surveyStateTypeName="{ item }">
        <span v-if="item.surveyStateType === 'EDITING'">
          <v-chip small disabled>
            {{ item.surveyStateTypeName }}
          </v-chip>
        </span>
        <span v-if="item.surveyStateType === 'PUBLISHED'">
          <v-chip small color="#03AC8C" text-color="white">
            {{ item.surveyStateTypeName }}
          </v-chip>
        </span>
      </template>
      <template v-slot:item.action="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              v-if="
                item.surveyStateType === 'EDITING' &&
                  check([{ domain: 'surveyAdm', permisions: ['Update'] }])
              "
              color="neuter"
              class="mr-2"
              small
              @click="publish(item)"
            >
              mdi-book-check-outline
            </v-icon>
          </template>
          <span>
            {{ $t("general.buttons.publish") }}
            <span style="font-size: 12px; color: #AAAAAA">
              {{ $t("menu.survey") }}
            </span>
          </span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              v-if="
                item.surveyStateType === 'EDITING' &&
                  check([{ domain: 'surveyAdm', permisions: ['Update'] }])
              "
              color="neuter"
              class="mr-2"
              small
              @click="editItem(item)"
            >
              mdi-square-edit-outline
            </v-icon>
          </template>
          <span>
            {{ $t("general.buttons.edit") }}
            <span style="font-size: 12px; color: #AAAAAA">
              {{ $t("menu.survey") }}
            </span>
          </span>
        </v-tooltip>
        <ConfirmDialog
          v-if="
                item.surveyStateType === 'PUBLISHED' &&
                  check([{ domain: 'surveyAdm', permisions: ['Update'] }])
              "
          :item="item"
          :is-icon="true"
          :is-tooltip="true"
          :is-btn="false"
          :title="$t('general.titles.information')"
          :dialog-text="$t('survey.notification.changeStateConfirm')"
          :tp-text="$t('general.buttons.edit')"
          :ts-text="$t('menu.survey')"
          :tooltip="true"
          btn-title=""
          btn-icon="mdi-square-edit-outline"
          color="neuter"
          action="changePublishStage"
        />
        <ConfirmDialog
          v-if="
                (item.surveyStateType === 'EDITING' ||
                  item.surveyStateType === 'PUBLISHED') &&
                  check([{ domain: 'surveyAdm', permisions: ['Delete'] }])
              "
          :item="item"
          :is-icon="true"
          :is-tooltip="true"
          :is-btn="false"
          :title="$t('general.titles.alert')"
          :dialog-text="$t('general.notification.deleteItems')"
          :tp-text="$t('general.buttons.delete')"
          :ts-text="$t('menu.survey')"
          :tooltip="true"
          btn-title=""
          btn-icon="mdi-trash-can-outline"
          color="neuter"
          action="deleteItem"
        />
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import i18n from "@/plugins/i18n";
import { mapActions, mapGetters } from "vuex";
import PermisionService from "../../../services/PermisionService";
import AddOrEditSurvey from "./AddOrEditSurvey";
import ConfirmDialog from "../../../components/ConfirmDialog";

export default {
  name: "Survey",
  components: {
    AddOrEditSurvey,
    ConfirmDialog,
  },
  data: () => ({
    expanded: [],
    profile: null,
    survey: [],
    search: "",
    title: "Información",
    dialogText: "Añada un texto a este dialogo",
    deletingItem: {},
    editingItem: {},
    confirmAction: null,
  }),

  mounted() {
    this.$root.$on('deleteItem', (item) => {
      this.deleteItem(item)
    })

    this.$root.$on('changePublishStage', (item) => {
      this.changePublishStage(item)
    })
  },

  computed: {
    ...mapGetters({
      loading: "survey/loading",
      requireAndMaxRules: "general/requireAndMaxRules",
      requireRules: "general/requireRules",
      surveyTemplateList: "survey/surveyTemplateList",
      error: "survey/error",
    }),
    headers: () => [
      { text: i18n.t("survey.fields.name"), value: "name" },
      { text: i18n.t("survey.fields.state"), value: "surveyStateTypeName" },
      {
        text: i18n.t("general.fields.action"),
        value: "action",
        width: 120,
        sortable: false,
        align: "center",
      },
    ],
  },
  created() {
    this.profile = JSON.parse(localStorage.getItem("profile"));
    this.getSuveyTemplate();
  },
  methods: {
    ...mapActions({
      fetchListSurveyTemplate: "survey/fetchListSurveyTemplate",
      deleteSurvey: "survey/deleteSurvey",
      change_state: "survey/change_state",
      errorOFF: "survey/errorOFF",
    }),
    // Get Survey by Company
    getSuveyTemplate() {
      const filter = {
        surveyStateType: ["PUBLISHED", "EDITING"],
        checkAccess: false
      };
      this.fetchListSurveyTemplate([filter, this.$toast]);
    },
    // Add new Survey
    addItem() {
      localStorage.removeItem("survey");
      this.$router.push({ name: "surveyAdd" });
    },
    // Edit new Survey
    editItem(item) {
      localStorage.setItem("survey", JSON.stringify(item.id));
      this.$router.push({ name: "surveyAdd" });
    },
    // Delete Survey
    deleteItem(item) {
      this.deleteSurvey([item.id, this.$toast]).finally(() => {
        this.getSuveyTemplate();
      });
    },
    // Publish Survey
    publish(item) {
      const changeStateDTO = {
        surveyStateType: "PUBLISHED",
        surveyId: item.id,
      };
      this.changeStateSurvey(changeStateDTO).finally(() => {
        this.getSuveyTemplate();
      });
    },
    // Change to editing state for edit Survey
    changePublishStage(item) {
      const changeStateDTO = {
        surveyStateType: "EDITING",
        surveyId: item.id,
      };
      this.changeStateSurvey(changeStateDTO).finally(() => {
        if (!this.error) {
          this.editItem(item);
        } else {
          this.errorOFF();
        }
      });
    },
    // Survey State Change
    changeStateSurvey(changeStateDTO) {
      return this.change_state([changeStateDTO, this.$toast]);
    },
    // Check permition for actions
    check(permisions) {
      return PermisionService.check(permisions);
    },
    // Confirm Dialog Show
    dialogShow(params) {
      this.title = params.title;
      this.dialogText = params.dialogText;
      this.$refs.dialogConfirm.openDialog();
    },
    // Confirm Dialog Close
    dialogClose() {
      this.$refs.dialogConfirm.dialogClose();
    },
    replace(event){
      event.currentTarget.value =  event.currentTarget.value.toString().replaceAll('"','')
      this.search =  event.currentTarget.value.toString().replaceAll('"','')
    }
  },

  destroyed() {
    this.$root.$off('deleteItem')
    this.$root.$off('changePublishStage')
  }
};
</script>

<style scoped></style>
